import React, { useEffect } from "react";

import { Container } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import ApplicationInstructions from "../../components/Common/ApplicationInstructions";
import NewsTicker from "../../components/Common/NewsTicker";
import Applicant from "../Applicant/Applicant";
import Application from "../Application/Application";

// Import news ticker configuration
import { getCurrentNewsMessage, getNewsTickerTheme, NEWS_TICKER_CONFIG } from "../../constants/newsTicker";

const Dashboard = () => {
  document.title = "Home | Moeen Memorial";

  // Ensure body has no background classes from login/register pages
  useEffect(() => {
    document.body.className = "";
    document.body.removeAttribute("class");
  }, []);

  // Get news ticker configuration
  const newsMessage = getCurrentNewsMessage();
  const themeConfig = getNewsTickerTheme();

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Moeen Memorial" breadcrumbItem="Home" />
          <NewsTicker 
            message={newsMessage}
            backgroundColor={themeConfig.backgroundColor}
            textColor={themeConfig.textColor}
            speed={NEWS_TICKER_CONFIG.DISPLAY_SETTINGS.DEFAULT_SPEED}
            pauseOnHover={NEWS_TICKER_CONFIG.DISPLAY_SETTINGS.PAUSE_ON_HOVER}
            showIcon={NEWS_TICKER_CONFIG.DISPLAY_SETTINGS.SHOW_ICON}
          />
          <Applicant/>
          <ApplicationInstructions />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
